import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

//import { LeadsTable } from './leads-table.component';

import { HubService } from '../services/hub.service';
import { AppComponent } from '../app.component';
import { LeadDetails } from '../types/leads';
import { Color, color } from 'd3';

@Component({
  selector: 'dash',
  templateUrl: './dash.component.html',
  styleUrls: ['./dash.component.css'],
  providers: [HubService],
})

export class DashComponent implements OnInit {
  leadsDetails = <LeadDetails[]>[];
  signupDetails = <LeadDetails[]>[];
  private refreshFrom: string = null;
  errorMessage: string;
  public uploadFlag: boolean = false;
  public mastersheetFlag: boolean = false;
  public newleadsFlag: boolean = false;
  public ecmsFlag: boolean = false;
  public reportsFlag: boolean = false;

  uploadToggle: boolean = false;
  masterSheetToggle: boolean = false;
  leadsToggle: boolean = false;
  ecmsToggle: boolean = false;
  reportsToggle: boolean = false;
  issuesToggle: boolean = false;

  interval: any;

  static handleRefreshError(err: any): void {
    if (err.status !== 401) {
      console.log('Hub Mail: ' + err);
    }
  }

  constructor(
    //@ViewChild(LeadsTable) private leadstable: LeadsTable,
    //private hubService: HubService,
    //private route: ActivatedRoute,
    //private router: Router,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
  }

  displayUpload(): void {
    this.uploadToggle = !this.uploadToggle;
    this.uploadFlag = !this.uploadFlag;
    this.ecmsToggle = this.ecmsFlag = this.newleadsFlag = this.leadsToggle = this.masterSheetToggle = this.mastersheetFlag = false;
  }

  getColor(toggle: boolean): any{
    if (toggle == true){
      return '#c2185b' ;
    }else{
      return '#DDD';
    }
  }

  displayMasterSheet(): void {
    this.masterSheetToggle = !this.masterSheetToggle;
    this.mastersheetFlag = !this.mastersheetFlag;
    this.uploadToggle =this.uploadFlag = this.newleadsFlag = this.leadsToggle = this.ecmsToggle = this.ecmsFlag = this.reportsToggle = this.reportsFlag = false;
  }

  displayNewLeads(): void {
    this.leadsToggle = !this.leadsToggle;
    this.newleadsFlag = !this.newleadsFlag;
    this.uploadToggle = this.uploadFlag =  this.masterSheetToggle = this.mastersheetFlag = this.ecmsToggle = this.ecmsFlag = this.reportsToggle = this.reportsFlag = false;
  }

  displayECMS(): void {
    console.log("Display ECMS......")
    this.ecmsToggle = !this.ecmsToggle;
    this.ecmsFlag = !this.ecmsFlag;
    this.uploadToggle = this.uploadFlag = this.newleadsFlag = this.leadsToggle =  this.masterSheetToggle = this.mastersheetFlag = this.reportsToggle = this.reportsFlag = false; 
  }

  displayReports(): void {
    this.reportsToggle = !this.reportsToggle;
    this.reportsFlag = !this.reportsFlag;
    this.uploadToggle = this.uploadFlag = this.newleadsFlag = this.leadsToggle = this.ecmsToggle = this.ecmsFlag = this.masterSheetToggle = this.mastersheetFlag = false;
  }

  receiveFlag($event: any) {
    this.refresh();
    this.uploadToggle = !this.uploadToggle;
    this.uploadFlag = $event;
  }

  refresh(): void {
  }

}

